// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SeamlessHomeLink_wrapper__8hWhe","back":"SeamlessHomeLink_back__dWSNs"};